import React from 'react'
import { BookingApp as LannisterBookingApp } from '@gonomadic/lannister'
import './booking-app.css'

const BookingApp = props => <LannisterBookingApp {...props} />

export default BookingApp
